import React from 'react';
import { Button } from '../components/ui/button';
import { Calculator, ArrowRight, Phone } from 'lucide-react';

const Header = ({ showStickyCTA, onOpenCalculator }) => {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <header className="header">
        <div className="container-custom">
          <div className="header-content">
            <a href="/" className="logo-container" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              <img 
                src="/logo.png" 
                alt="Sterbegeld Experten" 
                className="header-logo"
              />
            </a>
            <div className="header-buttons">
              <Button 
                onClick={onOpenCalculator}
                className="header-cta"
              >
                <Calculator size={18} />
                Kostenrechner starten
              </Button>
              <Button 
                onClick={scrollToForm}
                className="header-cta"
              >
                Jetzt Angebot anfordern
              </Button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
